var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasPageOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 226,
    viewBox: "0 0 178 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_29_18016)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 160,
    height: 208,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5 11V10.9979C168.495 9.69855 167.774 8.56446 166.695 7.77225C165.616 6.97982 164.15 6.50364 162.553 6.5H162.552L15.4483 6.5L15.4471 6.5C13.8498 6.50364 12.3843 6.97982 11.3049 7.77225C10.2259 8.56447 9.50549 9.69856 9.5 10.9979H9.5V11V23V23.5H10H168H168.5V23V11Z",
    fill: "#E5E8F5",
    stroke: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.2402H24V18.4802H18V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 12.2402H34V18.4802H28V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 12.2402H44V18.4802H38V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 12.2402H113V18.4802H58V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 37,
    width: 55,
    height: 8,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 53,
    width: 55,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 66,
    width: 32.4016,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 79,
    width: 42,
    height: 11,
    rx: 2.06557,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3591 86.7417V82.6106H41.0131C41.317 82.6106 41.5705 82.6556 41.7736 82.7457C41.9767 82.8358 42.1293 82.9609 42.2315 83.1209C42.3337 83.2796 42.3848 83.4625 42.3848 83.6696C42.3848 83.8309 42.3525 83.9728 42.288 84.0952C42.2234 84.2162 42.1347 84.3157 42.0217 84.3937C41.9101 84.4704 41.7823 84.5248 41.6384 84.5571V84.5975C41.7958 84.6042 41.943 84.6486 42.0802 84.7306C42.2187 84.8126 42.331 84.9276 42.4171 85.0755C42.5031 85.2221 42.5462 85.3969 42.5462 85.6C42.5462 85.8192 42.4917 86.0148 42.3828 86.187C42.2752 86.3578 42.1158 86.4929 41.9047 86.5924C41.6936 86.6919 41.4334 86.7417 41.1241 86.7417H39.3591ZM40.2325 86.0276H40.9445C41.1879 86.0276 41.3655 85.9812 41.4771 85.8884C41.5887 85.7943 41.6445 85.6692 41.6445 85.5132C41.6445 85.3989 41.6169 85.2981 41.5618 85.2107C41.5067 85.1233 41.428 85.0547 41.3258 85.0049C41.2249 84.9552 41.1046 84.9303 40.9647 84.9303H40.2325V86.0276ZM40.2325 84.3393H40.88C40.9997 84.3393 41.1059 84.3184 41.1987 84.2767C41.2928 84.2337 41.3668 84.1732 41.4206 84.0952C41.4757 84.0172 41.5033 83.9237 41.5033 83.8148C41.5033 83.6655 41.4502 83.5452 41.3439 83.4537C41.239 83.3623 41.0898 83.3166 40.8961 83.3166H40.2325V84.3393ZM46.9108 84.6761C46.9108 85.1266 46.8254 85.5099 46.6546 85.8259C46.4852 86.1419 46.2539 86.3833 45.9607 86.5501C45.6689 86.7155 45.3408 86.7982 44.9763 86.7982C44.6092 86.7982 44.2798 86.7148 43.9879 86.5481C43.6961 86.3813 43.4655 86.1399 43.2961 85.8239C43.1266 85.5079 43.0419 85.1253 43.0419 84.6761C43.0419 84.2256 43.1266 83.8424 43.2961 83.5263C43.4655 83.2103 43.6961 82.9696 43.9879 82.8042C44.2798 82.6374 44.6092 82.5541 44.9763 82.5541C45.3408 82.5541 45.6689 82.6374 45.9607 82.8042C46.2539 82.9696 46.4852 83.2103 46.6546 83.5263C46.8254 83.8424 46.9108 84.2256 46.9108 84.6761ZM46.0253 84.6761C46.0253 84.3843 45.9816 84.1382 45.8942 83.9378C45.8081 83.7375 45.6864 83.5855 45.529 83.482C45.3717 83.3784 45.1875 83.3266 44.9763 83.3266C44.7652 83.3266 44.581 83.3784 44.4236 83.482C44.2663 83.5855 44.1439 83.7375 44.0565 83.9378C43.9705 84.1382 43.9274 84.3843 43.9274 84.6761C43.9274 84.9679 43.9705 85.214 44.0565 85.4144C44.1439 85.6148 44.2663 85.7667 44.4236 85.8703C44.581 85.9738 44.7652 86.0256 44.9763 86.0256C45.1875 86.0256 45.3717 85.9738 45.529 85.8703C45.6864 85.7667 45.8081 85.6148 45.8942 85.4144C45.9816 85.214 46.0253 84.9679 46.0253 84.6761ZM47.2119 83.3307V82.6106H50.6047V83.3307H49.34V86.7417H48.4766V83.3307H47.2119ZM51.3707 86.7417H50.4348L51.8609 82.6106H52.9865L54.4106 86.7417H53.4746L52.4398 83.5546H52.4076L51.3707 86.7417ZM51.3123 85.1179H53.5231V85.7997H51.3123V85.1179ZM51.8448 82.2031L51.3687 82.197C51.3687 81.9402 51.4319 81.7432 51.5583 81.606C51.6848 81.4688 51.8401 81.3996 52.0243 81.3982C52.1184 81.3982 52.1991 81.4137 52.2664 81.4446C52.3336 81.4742 52.3948 81.5092 52.4499 81.5495C52.5051 81.5899 52.5575 81.6255 52.6073 81.6564C52.657 81.686 52.7108 81.7008 52.7686 81.7008C52.8466 81.6995 52.9058 81.6706 52.9462 81.6141C52.9878 81.5562 53.0087 81.4809 53.0087 81.3882L53.4787 81.4023C53.476 81.6564 53.4114 81.8528 53.285 81.9913C53.1586 82.1285 53.004 82.1977 52.8211 82.1991C52.7216 82.2004 52.6375 82.1856 52.5689 82.1547C52.5017 82.1237 52.4425 82.0888 52.3914 82.0498C52.3403 82.0094 52.2906 81.9738 52.2422 81.9429C52.1937 81.9119 52.1393 81.8965 52.0788 81.8965C52.0088 81.8965 51.9524 81.924 51.9093 81.9792C51.8663 82.0343 51.8448 82.109 51.8448 82.2031ZM58.51 84.6761C58.51 85.1266 58.4246 85.5099 58.2538 85.8259C58.0844 86.1419 57.8531 86.3833 57.5599 86.5501C57.2681 86.7155 56.94 86.7982 56.5755 86.7982C56.2084 86.7982 55.8789 86.7148 55.5871 86.5481C55.2953 86.3813 55.0647 86.1399 54.8952 85.8239C54.7258 85.5079 54.6411 85.1253 54.6411 84.6761C54.6411 84.2256 54.7258 83.8424 54.8952 83.5263C55.0647 83.2103 55.2953 82.9696 55.5871 82.8042C55.8789 82.6374 56.2084 82.5541 56.5755 82.5541C56.94 82.5541 57.2681 82.6374 57.5599 82.8042C57.8531 82.9696 58.0844 83.2103 58.2538 83.5263C58.4246 83.8424 58.51 84.2256 58.51 84.6761ZM57.6245 84.6761C57.6245 84.3843 57.5807 84.1382 57.4933 83.9378C57.4073 83.7375 57.2856 83.5855 57.1282 83.482C56.9709 83.3784 56.7867 83.3266 56.5755 83.3266C56.3644 83.3266 56.1802 83.3784 56.0228 83.482C55.8655 83.5855 55.7431 83.7375 55.6557 83.9378C55.5696 84.1382 55.5266 84.3843 55.5266 84.6761C55.5266 84.9679 55.5696 85.214 55.6557 85.4144C55.7431 85.6148 55.8655 85.7667 56.0228 85.8703C56.1802 85.9738 56.3644 86.0256 56.5755 86.0256C56.7867 86.0256 56.9709 85.9738 57.1282 85.8703C57.2856 85.7667 57.4073 85.6148 57.4933 85.4144C57.5807 85.214 57.6245 84.9679 57.6245 84.6761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 42,
    width: 49,
    height: 48,
    rx: 4,
    fill: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 38,
    width: 49,
    height: 48,
    rx: 3,
    stroke: "#4C6FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.075 66.6916L114.629 62.392C113.733 61.2741 111.987 61.4331 111.308 62.6944L105.588 73.3146C104.87 74.6471 105.835 76.263 107.349 76.263H137.622C139.142 76.263 140.106 74.6339 139.375 73.3011L130.012 56.232C129.237 54.8193 127.195 54.856 126.471 56.2956L121.423 66.3391C120.768 67.6408 118.986 67.8285 118.075 66.6916Z",
    fill: "white",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.193,
    cy: 52.8947,
    r: 2.89474,
    fill: "white",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 115,
    width: 27.0889,
    height: 26.8773,
    rx: 3,
    stroke: "#4C6FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 147.877,
    width: 32.4016,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 157.877,
    width: 22,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.7992,
    y: 115,
    width: 27.0889,
    height: 26.8773,
    rx: 3,
    stroke: "#4C6FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.7992,
    y: 147.877,
    width: 32.4016,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.7992,
    y: 157.877,
    width: 22,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.598,
    y: 115,
    width: 27.0889,
    height: 26.8773,
    rx: 3,
    stroke: "#4C6FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.598,
    y: 147.877,
    width: 32.4016,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.598,
    y: 157.877,
    width: 22,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 181,
    width: 122,
    height: 8,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 197,
    width: 67,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 6.5,
    width: 159,
    height: 207,
    rx: 5.5,
    stroke: "#D0D4E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29_18016",
    x: 0,
    y: 0,
    width: 178,
    height: 226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_29_18016"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29_18016"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29_18016",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasPageOthers);
export default __webpack_public_path__ + "static/media/canvas_page_others.b9b72002b608c4cbdf1191bab2337b0d.svg";
export { ForwardRef as ReactComponent };